import React from "react";
import { Routes, Route } from "react-router-dom";
import ListReward from "../Components/Reward Voucher/listReward";
import EditReward from "../Components/Reward Voucher/editReward";
import ListRewardPoints from "../Components/Reward Point/listReward";
import ListUserRewards from "../Components/Reward User/listReward";
import ListDoneUserRewards from "../Components/Reward User Done/listDoneReward";
import ViewDoneUserRewards from "../Components/Reward User Done/viewDoneReward";
import ViewUserRewards from "../Components/Reward User/viewReward";
import SignupListReferrals from "../Components/Referrals/signupReferral";
import RewardsHeaderList from "../Components/Rewards/rewardsHeader";
import ViewRewards from "../Components/Reward Voucher/viewReward";
import AddRewards from "../Components/Reward Voucher/addReward";
import AddRewardPoints from "../Components/Reward Point/addReward";
import UpdateRewardPoints from "../Components/Reward Point/editReward";

const RewardsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/rewards"
        element={<RewardsHeaderList></RewardsHeaderList>}
      ></Route>
      <Route
        path="/list_voucher_rewards"
        element={<ListReward></ListReward>}
      ></Route>
      <Route
        path="/rewards_voucher/edit/:id"
        element={<EditReward></EditReward>}
      ></Route>
      <Route
        path="/list_point_rewards"
        element={<ListRewardPoints></ListRewardPoints>}
      ></Route>
      <Route
        path="/list_user_rewards"
        element={<ListUserRewards></ListUserRewards>}
      ></Route>
      <Route
        path="/list_done_user_rewards"
        element={<ListDoneUserRewards></ListDoneUserRewards>}
      ></Route>
      <Route
        path="/signup_referrals"
        element={<SignupListReferrals></SignupListReferrals>}
      ></Route>
      <Route
        path="/rewards_voucher/view/:id"
        element={<ViewRewards></ViewRewards>}
      ></Route>
      <Route
        path="/rewards_voucher/add"
        element={<AddRewards></AddRewards>}
      ></Route>


      <Route
        path="/rewards_point/add"
        element={<AddRewardPoints></AddRewardPoints>}
      ></Route>
      <Route
        path="/rewards_point/edit/:id"
        element={<UpdateRewardPoints></UpdateRewardPoints>}
      ></Route>


      <Route
        path="/rewards_user_point/view/:id"
        element={<ViewUserRewards></ViewUserRewards>}
      ></Route>

      <Route
        path="/done_user_rewards/view/:id"
        element={<ViewDoneUserRewards></ViewDoneUserRewards>}
      ></Route>

      
    </Routes>
  );
};

export default RewardsRoutes;
